import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-navy text-cream min-h-[90vh] flex items-center overflow-hidden" data-id="element-74">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-75">
        <img src="https://cdn.magicpatterns.com/uploads/cwqmZM86KhyKCHXRwGgD7x/heylloyd-image-1777893282846.png" alt="Mujer profesional trabajando elegantemente" className="w-full h-full object-cover object-center opacity-40" data-id="element-76" />
        <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/90 to-navy/40" data-id="element-77"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-6 md:px-12 py-20 md:py-32 grid md:grid-cols-2 gap-12 items-center" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-79">
          <div className="inline-block border border-gold/50 text-gold px-4 py-1 rounded-full text-xs tracking-widest uppercase mb-8 font-medium" data-id="element-80">
            Para mujeres profesionales 45+
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif leading-tight mb-6 text-cream" data-id="element-81">
            Deja de ser invisible en TikTok y reclama la autoridad que tus años
            de experiencia ya te han dado.
          </h1>
          <p className="text-lg md:text-xl text-cream-dark/90 font-light leading-relaxed mb-10 max-w-xl" data-id="element-82">
            <strong className="font-medium text-gold-light" data-id="element-83">
              El Protocolo de Influencia Visual:
            </strong>{' '}
            Cómo construir una marca personal respetada, elegante y rentable sin
            necesidad de bailar, seguir tendencias ridículas o usar filtros que
            no te representan.
          </p>
          <Button onClick={scrollToPricing} data-id="element-84">
            Quiero empezar mi segundo acto ahora
          </Button>
        </motion.div>
      </div>
    </section>;
}